import { configureStore } from '@reduxjs/toolkit';
import { casOpsApi } from './api';
import authReducer from './slices/authSlice';
import prefsReducer from './slices/prefsSlice';
import globalReducer from './slices/globalSlice';
import gridReducer from './slices/gridSlice';
import settingsReducer from './slices/settingsSlice';
import { filtersReducer } from './slices/filtersSlice';
import mapReducer from './slices/mapSlice';
import geofenceEditorReducer from './slices/geofenceEditorSlice';
import assetTracksReducer from './slices/assetTracksSlice';

export const store = configureStore({
  reducer: {
    api: casOpsApi.reducer,
    auth: authReducer,
    prefs: prefsReducer,
    global: globalReducer,
    grid: gridReducer,
    filters: filtersReducer,
    map: mapReducer,
    settings: settingsReducer,
    geofenceEditor: geofenceEditorReducer,
    assetTracks: assetTracksReducer,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(casOpsApi.middleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
